module.exports = __webpack_public_path__ + "static/media/tconecta.cf7cf549.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/logos/tconecta.png
// module id = 693
// module chunks = 0